const ACTIVITY_REQUEST =
  /\b(run counts?|conversation counts?|simulation counts?|(?:run|job|execution) completion rates?|execution status|in.progress runs?)\b|\b(how many|number of|count of) (scheduled )?(runs?|conversations?|simulations?|jobs?)\b|\b(show|include|report|summarize|track|focus on) (platform |run |conversation )?usage\b(?!\s+(?:success|quality|accuracy|effectiveness|outcomes?)\b)|^\s*usage\s*$/i
const EXCLUSION =
  /\b(no|not|never|without|exclude|hide|ignore|omit|skip|avoid|stop)\b|don['’]t/i

/** Explicit exclusions take precedence because activity is emitted as one group. */
export function requestsSummaryActivity(
  text: string | null | undefined,
): boolean {
  const clauses = (text ?? "").split(/[.;\n]/)
  if (
    clauses.some(
      (clause) => EXCLUSION.test(clause) && ACTIVITY_REQUEST.test(clause),
    )
  ) {
    return false
  }
  return clauses.some(
    (clause) => !EXCLUSION.test(clause) && ACTIVITY_REQUEST.test(clause),
  )
}
